import axios from 'axios';
import { API_URL } from '../data/constant';

const axiosInstance = axios.create({ baseURL: API_URL });
let redirecting = false;
const requireLogin = (reason) => {
  localStorage.removeItem('token');
  localStorage.removeItem('user_id');
  if (!redirecting && !window.location.pathname.startsWith('/login')) {
    redirecting = true;
    window.location.replace(`/login?reason=${reason}`);
  }
};
axiosInstance.interceptors.response.use(
  (response) => {
    if (response.data?.reauthenticate) requireLogin('password_changed');
    return response;
  },
  (error) => {
    const endpoint = error.config?.url || '';
    if (error.response?.status === 401 && !endpoint.includes('partner/login') && !endpoint.includes('auth/logout')) requireLogin('session_expired');
    return Promise.reject(error);
  }
);
export default axiosInstance;
